
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as searchWiCwPORWRkcZm1zH29UWKNMF4Vb5hM_q5Mi2yI40hlcMeta } from "/app/pages/search.vue?macro=true";
import { default as signinawKlupfeildDdXrIM2LPmI5jOdsD7WNv6lb6o6QgkAEMeta } from "/app/pages/signin.vue?macro=true";
import { default as signupXDZ9vem3RhITR7dUmFJxupvJgksTCjysSig_ObPaBwEMeta } from "/app/pages/signup.vue?macro=true";
import { default as preview5d59c0NdFJyN9ePPjQ0xh_Ke3_LpJ015GPjpKMAj53sMeta } from "/app/pages/preview.vue?macro=true";
import { default as signout8xYhb_wZOAkH2DbUU_KiJ5KWOGY_45W9UOupv9zxgDHjkMeta } from "/app/pages/signout.vue?macro=true";
import { default as index5pAncILkXJ_EDtr4snr6gZ88fS6F3gsPDzDN4Vl_4aoMeta } from "/app/pages/talks/index.vue?macro=true";
import { default as editZBKHq45q67yiBF3FiHxAaGOkw_45TMcifAAfnfD5_457zHIMeta } from "/app/pages/profile/edit.vue?macro=true";
import { default as _91slug_93rxmSCSpj4l_45GFXRvMb9tlV00JSY6oqba4j3sCNhoYkAMeta } from "/app/pages/talks/[slug].vue?macro=true";
import { default as _91slug_93sragQC0grlphUP7VqatcYKwZOAXW54E4jWAJuBV9AiEMeta } from "/app/pages/people/[slug].vue?macro=true";
import { default as indexPYMehh1H3I51I_Jt_45B2w91jhAIWvwCrr7OI55V5sjLcMeta } from "/app/pages/profile/index.vue?macro=true";
import { default as resetpasswordpGI8faRxEF74NM8rmLBWHFArkewSXQHwKyA_Rn3UkDgMeta } from "/app/pages/resetpassword.vue?macro=true";
import { default as indexvtTLD5wwWrAtth0PWcCLRe2BsaBbtCcYfToThzM1eqgMeta } from "/app/pages/studies/index.vue?macro=true";
import { default as _91slug_93vwNKa_FU2o8J2IBbzSUrw3b5_45Ll99vq1T5Zb4jaD7qkMeta } from "/app/pages/topics/[slug].vue?macro=true";
import { default as indexldltIOcPnmwFdh_pZg_45p_DCKdX9_452BTT9Ow95xFCG2MMeta } from "/app/pages/worship/index.vue?macro=true";
import { default as index9j3HrWpRPsPPlMB7_45YSFbtoOPNwVLFXfBC_vX1oMrfkMeta } from "/app/pages/articles/index.vue?macro=true";
import { default as forgotpasswordpkq5r_45Qy0r4XUFBE6P_7x7794tbAxBCVgLQ7nOG5A1AMeta } from "/app/pages/forgotpassword.vue?macro=true";
import { default as indexwk_45PYCByCydXJjfnfsNw7FQNiMJIE_45UQ0jOAlSk_UPAMeta } from "/app/pages/podcasts/index.vue?macro=true";
import { default as _91slug_93NdCzzbzWoMvwOWkW9jSHmwismy_45h6SZBhc0dh3WpdxcMeta } from "/app/pages/worship/[slug].vue?macro=true";
import { default as _91slug_93SWICtd0KwicWa0riu8_458_EdoWCQx9HeWtBicMxtuzIwMeta } from "/app/pages/articles/[slug].vue?macro=true";
import { default as _91slug_93xdYXkv24rcvkNMI7d_BkX_45jpiFwr5yYi0sBGiAdY5IIMeta } from "/app/pages/podcasts/[slug].vue?macro=true";
import { default as indexf_OU9iNEdgKYa4i4iWiE3p1aU9n8CdtqMDKSl4DpXXwMeta } from "/app/pages/studies/[slug]/index.vue?macro=true";
import { default as indexdhzTL8vLRVgDVQy_45_2_64V62HDtEttAFS8nTkZoFOQQMeta } from "/app/pages/collections/[slug]/index.vue?macro=true";
import { default as collections78l8EVuzO1xTAIk8miA_xs52dm1LaIYPtlZeSjVTfSYMeta } from "/app/pages/collections/[slug]/collections.vue?macro=true";
import { default as index95L_45gEtS5_XZO1lCwXAfAohSoNLAC23C672nmUa45pcMeta } from "/app/pages/studies/[slug]/[sessionslug]/index.vue?macro=true";
import { default as component_45stub4QoPlZXuwwVWrsKEn_uZtqL99GoLln_6x5cynRLIhSsMeta } from "/app/node_modules/.pnpm/nuxt@3.17.3_@parcel+watcher@2.5.1_@types+node@22.15.18_db0@0.3.2_eslint@9.27.0_jiti@2.4_cb5d5c2af6a1239fe3ab7b3d8a03f010/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub4QoPlZXuwwVWrsKEn_uZtqL99GoLln_6x5cynRLIhSs } from "/app/node_modules/.pnpm/nuxt@3.17.3_@parcel+watcher@2.5.1_@types+node@22.15.18_db0@0.3.2_eslint@9.27.0_jiti@2.4_cb5d5c2af6a1239fe3ab7b3d8a03f010/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___en",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "search___en",
    path: "/search",
    meta: searchWiCwPORWRkcZm1zH29UWKNMF4Vb5hM_q5Mi2yI40hlcMeta || {},
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "signin___en",
    path: "/signin",
    meta: signinawKlupfeildDdXrIM2LPmI5jOdsD7WNv6lb6o6QgkAEMeta || {},
    component: () => import("/app/pages/signin.vue")
  },
  {
    name: "signup___en",
    path: "/signup",
    meta: signupXDZ9vem3RhITR7dUmFJxupvJgksTCjysSig_ObPaBwEMeta || {},
    component: () => import("/app/pages/signup.vue")
  },
  {
    name: "preview___en",
    path: "/preview",
    component: () => import("/app/pages/preview.vue")
  },
  {
    name: "signout___en",
    path: "/signout",
    meta: signout8xYhb_wZOAkH2DbUU_KiJ5KWOGY_45W9UOupv9zxgDHjkMeta || {},
    component: () => import("/app/pages/signout.vue")
  },
  {
    name: "talks___en",
    path: "/talks",
    meta: index5pAncILkXJ_EDtr4snr6gZ88fS6F3gsPDzDN4Vl_4aoMeta || {},
    component: () => import("/app/pages/talks/index.vue")
  },
  {
    name: "profileSettings___en",
    path: "/profile/edit",
    meta: editZBKHq45q67yiBF3FiHxAaGOkw_45TMcifAAfnfD5_457zHIMeta || {},
    component: () => import("/app/pages/profile/edit.vue")
  },
  {
    name: "talks-slug___en",
    path: "/talks/:slug()",
    component: () => import("/app/pages/talks/[slug].vue")
  },
  {
    name: "people-slug___en",
    path: "/people/:slug()",
    component: () => import("/app/pages/people/[slug].vue")
  },
  {
    name: "myProfile___en",
    path: "/profile",
    meta: indexPYMehh1H3I51I_Jt_45B2w91jhAIWvwCrr7OI55V5sjLcMeta || {},
    component: () => import("/app/pages/profile/index.vue")
  },
  {
    name: "resetPassword___en",
    path: "/resetpassword",
    meta: resetpasswordpGI8faRxEF74NM8rmLBWHFArkewSXQHwKyA_Rn3UkDgMeta || {},
    component: () => import("/app/pages/resetpassword.vue")
  },
  {
    name: "studies___en",
    path: "/studies",
    meta: indexvtTLD5wwWrAtth0PWcCLRe2BsaBbtCcYfToThzM1eqgMeta || {},
    component: () => import("/app/pages/studies/index.vue")
  },
  {
    name: "topics-slug___en",
    path: "/topics/:slug()",
    component: () => import("/app/pages/topics/[slug].vue")
  },
  {
    name: "worship___en",
    path: "/worship",
    meta: indexldltIOcPnmwFdh_pZg_45p_DCKdX9_452BTT9Ow95xFCG2MMeta || {},
    component: () => import("/app/pages/worship/index.vue")
  },
  {
    name: "articles___en",
    path: "/articles",
    meta: index9j3HrWpRPsPPlMB7_45YSFbtoOPNwVLFXfBC_vX1oMrfkMeta || {},
    component: () => import("/app/pages/articles/index.vue")
  },
  {
    name: "forgotPassword___en",
    path: "/forgotpassword",
    meta: forgotpasswordpkq5r_45Qy0r4XUFBE6P_7x7794tbAxBCVgLQ7nOG5A1AMeta || {},
    component: () => import("/app/pages/forgotpassword.vue")
  },
  {
    name: "podcasts___en",
    path: "/podcasts",
    meta: indexwk_45PYCByCydXJjfnfsNw7FQNiMJIE_45UQ0jOAlSk_UPAMeta || {},
    component: () => import("/app/pages/podcasts/index.vue")
  },
  {
    name: "worship-slug___en",
    path: "/worship/:slug()",
    component: () => import("/app/pages/worship/[slug].vue")
  },
  {
    name: "articles-slug___en",
    path: "/articles/:slug()",
    component: () => import("/app/pages/articles/[slug].vue")
  },
  {
    name: "podcasts-slug___en",
    path: "/podcasts/:slug()",
    component: () => import("/app/pages/podcasts/[slug].vue")
  },
  {
    name: "studies-slug___en",
    path: "/studies/:slug()",
    component: () => import("/app/pages/studies/[slug]/index.vue")
  },
  {
    name: "collections-slug___en",
    path: "/collections/:slug()",
    component: () => import("/app/pages/collections/[slug]/index.vue")
  },
  {
    name: "collections-slug-collections___en",
    path: "/collections/:slug()/collections",
    component: () => import("/app/pages/collections/[slug]/collections.vue")
  },
  {
    name: "studies-slug-sessionslug___en",
    path: "/studies/:slug()/:sessionslug()",
    component: () => import("/app/pages/studies/[slug]/[sessionslug]/index.vue")
  },
  {
    name: component_45stub4QoPlZXuwwVWrsKEn_uZtqL99GoLln_6x5cynRLIhSsMeta?.name,
    path: "/topic/:pathMatch(.*)",
    component: component_45stub4QoPlZXuwwVWrsKEn_uZtqL99GoLln_6x5cynRLIhSs
  },
  {
    name: component_45stub4QoPlZXuwwVWrsKEn_uZtqL99GoLln_6x5cynRLIhSsMeta?.name,
    path: "/songs/:pathMatch(.*)",
    component: component_45stub4QoPlZXuwwVWrsKEn_uZtqL99GoLln_6x5cynRLIhSs
  },
  {
    name: component_45stub4QoPlZXuwwVWrsKEn_uZtqL99GoLln_6x5cynRLIhSsMeta?.name,
    path: "/messages/:pathMatch(.*)",
    component: component_45stub4QoPlZXuwwVWrsKEn_uZtqL99GoLln_6x5cynRLIhSs
  },
  {
    name: component_45stub4QoPlZXuwwVWrsKEn_uZtqL99GoLln_6x5cynRLIhSsMeta?.name,
    path: "/devotionals/:pathMatch(.*)",
    component: component_45stub4QoPlZXuwwVWrsKEn_uZtqL99GoLln_6x5cynRLIhSs
  },
  {
    name: component_45stub4QoPlZXuwwVWrsKEn_uZtqL99GoLln_6x5cynRLIhSsMeta?.name,
    path: "/tracks/:pathMatch(.*)",
    component: component_45stub4QoPlZXuwwVWrsKEn_uZtqL99GoLln_6x5cynRLIhSs
  },
  {
    name: component_45stub4QoPlZXuwwVWrsKEn_uZtqL99GoLln_6x5cynRLIhSsMeta?.name,
    path: "/today",
    component: component_45stub4QoPlZXuwwVWrsKEn_uZtqL99GoLln_6x5cynRLIhSs
  },
  {
    name: component_45stub4QoPlZXuwwVWrsKEn_uZtqL99GoLln_6x5cynRLIhSsMeta?.name,
    path: "/discover",
    component: component_45stub4QoPlZXuwwVWrsKEn_uZtqL99GoLln_6x5cynRLIhSs
  }
]